import type { GeneralErrand } from '@pigello/pigello-matrix';
import { createDelegationOfferHandler } from './shared-delegation-offer-handler';

// Custom handler for General Errand
export const handleCustomGeneralErrandNestedCase =
  createDelegationOfferHandler<GeneralErrand>(
    'general_errand',
    (offer) => offer.generalErrand?.id
  );
